export default __webpack_public_path__ + "static/media/logo1024.08d0ef9a.jpg";